export const iconFontAwesomeTextformattingItalic = (
	<i className="fa-solid fa-italic"></i>
);
